import React from "react";
import { getFullImageUrl } from "../../../../../utils/constants/constants";

const NegFbDetailHead = ({ cardData, storeName }) => {
  return (
    <div className="negative-feedback-head">
      <div className="card-logo-div">
        {cardData?.logo ? (
          <img
            width="100px"
            alt="card-logo"
            title="Brand Logo"
            className="card-logo-image"
            src={getFullImageUrl(cardData?.logo)}
          />
        ) : (
          <p
            style={{ color: cardData?.colors?.theme }}
            className="card-logo-name"
          >
            {storeName}
          </p>
        )}
      </div>
      <h4>Negative feedback details</h4>
    </div>
  );
};

export default NegFbDetailHead;
